// Profile Actions
export const FETCH_PROFILES = "FETCH_PROFILES";
export const FETCH_PROFILE_DETAILS = "FETCH_PROFILE_DETAILS";
export const ADD_PROFILE = "ADD_PROFILE";

// Authentication Actions
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";

// Preferences Actions
export const UPDATE_PREFERENCES = "UPDATE_PREFERENCES";
export const FETCH_PREFERENCES = "FETCH_PREFERENCES";


//export const FETCH_PROFILES = "FETCH_PROFILES"